import React from 'react';
import {
  Wrapper,
  ResultsTitle,
  DataContainer,
  DataItem,
  CWELink
} from './styled';

const getCweList = (cwe) => {
  if (Array.isArray(cwe)) return cwe.filter(Boolean);
  return cwe ? [cwe] : [];
};

const getCweUrl = (item) => `https://cwe.mitre.org/data/definitions/${item.replace(/^CWE-/i, '')}.html`;

const CWE = ({ currentVuln }) => {
  const validCwes = getCweList(currentVuln.cwe);

  if (validCwes.length === 0) return null;

  const isOdd = (index) => index % 2 !== 0;

  return (
    <Wrapper>
      <ResultsTitle>CWE</ResultsTitle>
      <DataContainer>
        {validCwes.map((item, index) => (
          <DataItem key={ `${item}-${index}` } isOdd={ isOdd(index) }>
            <CWELink
              href={ getCweUrl(item) }
              target="_blank"
              rel="noopener noreferrer"
            >
              {item}
            </CWELink>
          </DataItem>
        ))}
      </DataContainer>
    </Wrapper>
  );
};

export default CWE;
